import type { LucideIcon } from 'lucide-react';
import { findSection } from 'shared/constants/routes';
import {
  Archive,
  BookOpen,
  Circle,
  FileCheck,
  FileText,
  Home,
  Info,
  Settings,
  Users,
} from 'lucide-react';

const LABEL_ICON_MAP: Record<string, LucideIcon> = {
  Главная: Home,
  Поручения: FileCheck,
  Клиенты: Users,
  'Мои клиенты': Users,
  Портфель: Archive,
  Отчеты: FileText,
  Отчёты: FileText,
  Справочники: BookOpen,
  Администрирование: Settings,
  'О системе': Info,
};

/** UI-only icon resolver — does not affect routing or permissions.
 *  Иконка раздела задаётся в shared/constants/routes.ts; здесь только запасные
 *  варианты по названию группы и префиксу пути. */
export function resolveMenuIcon(link?: string, label?: string): LucideIcon {
  const icon = findSection(link)?.icon;
  if (icon) return icon;
  if (label && LABEL_ICON_MAP[label]) return LABEL_ICON_MAP[label];
  if (link?.startsWith('/dict/')) return BookOpen;
  if (link?.startsWith('/admin/')) return Settings;
  if (link?.startsWith('/documents')) return FileCheck;
  return Circle;
}

export function MenuIcon({
  link,
  label,
  className,
}: {
  link?: string;
  label?: string;
  className?: string;
}) {
  const Icon = resolveMenuIcon(link, label);
  return <Icon className={className ?? 'w-5 h-5'} aria-hidden />;
}
